import { useQueries } from "hooks/useQueries";
import {
  getAutoInvesting,
  getDashboardHistoricalChart,
  getTotalAccountValue,
} from "../service";

export const useAccountDetails = () => {
  const results = useQueries({
    queries: [
      {
        queryKey: ["autoInvesting"],
        queryFn: () => getAutoInvesting(),
        suspense: false,
      },
      {
        queryKey: ["totalAccountValue"],
        queryFn: () => getTotalAccountValue(),
        suspense: false,
      },
      {
        queryKey: ["historicalChart"],
        queryFn: () => getDashboardHistoricalChart(),
        suspense: false,
      },
    ],
  });

  const [autoInvesting, totalReturn, historicalChart] = results;

  const isLoading = results.some(
    (result) => result.isLoading || result.status === "loading" || !result.data
  );

  const refetch = async () => {
    const refetchPromises = results.map((result) => result.refetch());
    return Promise.all(refetchPromises);
  };

  return {
    data: autoInvesting.data,
    totalReturnValue: totalReturn.data,
    historicalData: historicalChart.data?.historical_charts,
    isLoading,
    isError: results.some((result) => result.isError),
    refetch,
  };
};
